import { DEVICE_TYPE } from "../../../enums";

export default {
  /** Get list of available video sources */
  videoSources(state) {
    return state.sources.filter(source => source.kind === DEVICE_TYPE.VIDEO);
  },
  /** Get list of available audio sources */
  audioSources(state) {
    return state.sources.filter(source => source.kind === DEVICE_TYPE.AUDIO);
  },
  /** Check if system has camera and supported by OT */
  isSystemSupported(state) {
    return state.hasVideoDevice && state.systemSupported;
  }
};
